import { create } from "zustand";

interface CentinelaConfigGuardState {
  hasChanges: boolean;
  save: () => void;
  discard: () => void;
  setHasChanges: (hasChanges: boolean) => void;
  register: (handlers: { save: () => void; discard: () => void }) => void;
  reset: () => void;
}

const noop = () => {};

export const useCentinelaConfigGuard = create<CentinelaConfigGuardState>((set) => ({
  hasChanges: false,
  save: noop,
  discard: noop,
  setHasChanges: (hasChanges) => set({ hasChanges }),
  register: ({ save, discard }) => set({ save, discard }),
  reset: () => set({ hasChanges: false, save: noop, discard: noop }),
}));
